export { };
export const defaults = {
	app: {
		applicationId: 'dsgvoreport',
		pageEditorClass: 'is-page-editor',

		validatorRules: {
			rules: {
				Delivery: {
					required: true
				},
				EmailRecovery: {
					email: true,
					required: true
				},
				Consent: {
					required: true
				}
			}
		},
		validationmessages: {
			client: {
				Delivery: {
					required: "Bitte wählen Sie eine Option!"
				},
				EmailRecovery: {
					email: "Bitte geben Sie Ihre E-Mail in korrekter Schreibweise ein.",
					required: "Bitte geben Sie eine E-Mail an!"
				},
				Consent: {
					required: "Bitte bestätigen Sie die Kenntnisnahme."
				}
			},
			backend: {}
		}
	}
};